import type { Event } from '@patsnap/tahiti-core/common/event';
import type { TranslationOptions, TargetPatent, Language } from '../types';

export const TranslationOptionsService = Symbol.for('TranslationOptionsService');

export interface TranslationOptionsService {
    readonly onStatesChange: Event<TranslationOptions>;

    getModelData(): TranslationOptions;
    getOptionLabel(lang: Language): string;
    initialize(target: TargetPatent): TranslationOptions;
}
